<template>
  <div class="stripe-elements">
    <form id="stripe-form">
      <div class="stripe-row">
        <fa icon="credit-card" />
        <span class="stripe-placeholder">Card number</span>
        <div id="divegas-card-number" class="input empty"></div>
      </div>
      <div class="split">
        <div class="stripe-row">
          <fa icon="clock" />
          <span class="stripe-placeholder">Card expiry</span>
          <div id="divegas-card-expiry" class="input empty"></div>
        </div>
        <div class="stripe-row">
          <fa icon="lock" />
          <span class="stripe-placeholder">Card CVC</span>
          <div id="divegas-card-cvc" class="input empty"></div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

var elementStyles = {
  base: {
    color: '#32325D',
    fontWeight: 500,
    fontFamily: 'Source Code Pro, Consolas, Menlo, monospace',
    fontSize: '13px',
    fontSmoothing: 'antialiased',

    '::placeholder': {
      color: '#CFD7DF'
    },
    ':-webkit-autofill': {
      color: '#e39f48'
    }
  },
  invalid: {
    color: '#E25950',

    '::placeholder': {
      color: '#FFCCA5'
    }
  }
}

var elementClasses = {
  focus: 'focused',
  empty: 'empty',
  invalid: 'invalid'
}

export default {
  name: 'Stripe',
  props: {
    getToken: Boolean,
    currency: String
  },
  data () {
    return {
      elements: [],
      stripe: Stripe(process.env.STRIPE_PUBLIC_KEY)
    }
  },
  watch: {
    getToken (val) {
      if (val) {
        this.createToken(this.elements)
      } 
    }
  },
  methods: {
    async createToken (elements) {
      const result = await this.stripe.createToken(elements[0], { currency: this.currency })
      if (result.token) {
        elements.forEach((element) => element.clear())
        this.$emit('success', result)
      } else {
        this.$emit('failed', result)
      }
    },
    submitFormHandler () {
      const form = document.querySelector('#stripe-form')
      form.addEventListener('submit', (e) => {
        e.preventDefault();
      })
    },
    initializeElements (elements) {
      let cardNumber = elements.create('cardNumber', {
        style: elementStyles,
        classes: elementClasses
      })
      cardNumber.mount('#divegas-card-number')

      let cardExpiry = elements.create('cardExpiry', {
        style: elementStyles,
        classes: elementClasses
      })
      cardExpiry.mount('#divegas-card-expiry')

      let cardCvc = elements.create('cardCvc', {
        style: elementStyles,
        classes: elementClasses
      })
      cardCvc.mount('#divegas-card-cvc')

      return [cardNumber, cardExpiry, cardCvc]
    },
    initializeForm () {
      let elements = this.stripe.elements({
        fonts: [{
          cssSrc: 'https://fonts.googleapis.com/css?family=Source+Code+Pro'
        }],
        locale: 'auto'
      })

      this.elements = this.initializeElements(elements)
      this.submitFormHandler()
    }
  },
  mounted () {
    this.initializeForm()
  }
}
</script>

<style lang="scss">
  
</style>



// WEBPACK FOOTER //
// src/components/dashboard/saldoAndCredit/stripe/Stripe.vue